import { sendGA4Event } from '../shared/sendGa4Event';

export interface MergeCartImpression {
    event: 'impression';
    type: 'merge_cart_popup';
    page_type: 'cart';
}

export interface MergeCartInteraction {
    event: 'interaction';
    type: 'merge_cart_popup';
    click_text: MergeCartClickOption;
}

export const displayMergeOptions = () => {
    sendGA4Event({
        event: 'impression',
        type: 'merge_cart_popup',
        page_type: 'cart',
    });
};

type MergeCartClickOption =
    | 'Lägg ihop varukorgar'
    | 'Använd ny varukorg'
    | 'Använd tidigare varukorg';

export const mergeCartInteraction = (clickOption: MergeCartClickOption) => {
    sendGA4Event({
        event: 'interaction',
        type: 'merge_cart_popup',
        click_text: clickOption,
    });
};
